module.exports = __webpack_public_path__ + "static/09-d999bebd0f21580f2e10cd9c6d7ba168.jpg";